<template>
  <section>
    <div class="kyc_title">
      <h4>{{ $t("Individual") }}</h4>
    </div>
    <a-steps
      type="navigation"
      :current="currentStep4Individual"
      class="steps"
      @change="onChange"
    >
      <a-step
        v-for="stepItem in kycStepLists"
        :key="stepItem.view"
        :status="stepItem.status"
        :title="$t(stepItem.title)"
      />
    </a-steps>
    <div class="kyc_container">
      <a-skeleton active :loading="!token" />
      <keep-alive>
        <component
          v-if="token"
          :is="currentStepView"
          :isBroker="isBroker"
        ></component>
      </keep-alive>
    </div>
    <tips-continue />
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Skeleton, Steps } from "ant-design-vue";
import TipsContinue from "../TipsContinue";
import PersonalInfo from "./PersonalInfo";
import Identification from "./Identification";
import BankingInfo from "./BankingInfo";
import Questionnaire from "./Questionnaire";

export default {
  name: "Kyc.Individual.Index",
  data() {
    return {};
  },
  props: {
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("KYC", ["currentStep4Individual", "kycStepLists4Individual"]),
    kycStepLists() {
      return this.kycStepLists4Individual.map(n => {
        if (this.isBroker && n.title === "Banking Info") {
          return { ...n, title: "Wallet Info" };
        } else {
          return n;
        }
      });
    },
    currentStepView() {
      return this.kycStepLists[this.currentStep4Individual].view;
    },
    currentStepStatus() {
      return this.kycStepLists[this.currentStep4Individual].status;
    }
  },
  components: {
    [Skeleton.name]: Skeleton,
    [Steps.name]: Steps,
    [Steps.Step.name]: Steps.Step,
    TipsContinue,
    PersonalInfo,
    Identification,
    BankingInfo,
    Questionnaire
  },
  methods: {
    ...mapActions("KYC", ["changeApplyType", "changeCurrentStep4Individual"]),
    onChange(stepIndex) {
      let { status } = this.kycStepLists4Individual[stepIndex];
      if (status === "wait") return; // 不可以直接点击状态为wait的step
      this.changeCurrentStep4Individual(stepIndex);
    }
  },
  created() {
    this.changeApplyType(0);
  }
};
</script>

<style lang="scss" scoped>
.steps {
  box-shadow: 0px -1px 0 0 #e8e8e8 inset;
  margin-bottom: 1rem;
}
</style>
